import React, { useEffect, useState, useContext } from 'react'
import ButtonModalOpen from '../../elements/ButtonModalOpen'
import Counter from '../../elements/Counter'

const arrayDays = ['lundi','mardi','mercredi','jeudi','vendredi','samedi','dimanche']

const ViewDaysStaff = ({ handleOpenDay, state, setChoiceDay, setCount, count, staff, _subtractNbrWeeks, _addNbrWeeks }) => {
    const [showDay, setShowDay] = useState()
    const [showWeeks, setShowWeeks] = useState(false)

    const _zero = (n) => {
        if (parseInt(n) === 0) return '00'
        if (parseInt(n) > 0 && parseInt(n) < 10) return ['0'+n]
        if (parseInt(n) > 9) return n
    }

    return (
        <>
        {staff.filter(s => s.id === state.idStaff).map(s => (
            <div key={s.id}>
            {arrayDays.map(day => (
                <div className="shadow row mt-3" key={day}>
                    <div className="card-body">
                        <div className='row' onClick={() => setShowDay(showDay === day ? '' : day)}>
                            <div className='col text-start'>
                                <div>
                                    <span>{day} : </span>
                                    <span>{s[day+'open'] === true ?  
                                    <>
                                        <span>
                                            {
                                                s[day+'amOpen'] === true &&
                                                '   ' +
                                                _zero(s[day+'hoursAMStart']) + ':' + 
                                                _zero(s[day+'minutesAMStart']) + '  -  ' +
                                                _zero(s[day+'hoursAMEnd']) + ':' + 
                                                _zero(s[day+'minutesAMEnd']) 
                                            }
                                        </span>
                                        <span>
                                            {
                                                s[day+'amOpen'] === true && s[day+'pmOpen'] === true && '  /  '
                                            }
                                        </span>
                                        <span>
                                            {
                                                s[day+'pmOpen'] === true && 
                                                '   ' +
                                                _zero(s[day+'hoursPMStart']) + ':' + 
                                                _zero(s[day+'minutesPMStart']) + '  -  ' +
                                                _zero(s[day+'hoursPMEnd']) + ':' + 
                                                _zero(s[day+'minutesPMEnd'])
                                            }
                                        </span>
                                    </>
                                    : 'fermé'}</span>
                                </div>

                            </div>
                            <div className='col-2 text-end'>
                                <i className={showDay === day ? "bi bi-chevron-compact-up" : "bi bi-chevron-compact-down"}></i>
                            </div>
                        </div>
                        {}
                        {showDay === day && 
                        <>
                            <div className='row text-center border-top mt-3 '>
                                <div className='col pt-3'>
                                    <p 
                                        style={{ cursor:'pointer' }} 
                                        className={s[day+'open'] === true ? 'bg-success py-2 rounded' : ' py-2 rounded'} 
                                        onClick={() => handleOpenDay(day,s.id,'ouvert')}
                                    >OUVERT</p>
                                </div>
                            
                                <div style={{ cursor:'pointer' }} className='col pt-3'>
                                    <p 
                                        className={s[day+'open'] === true ? ' py-2 rounded' : 'bg-danger py-2 rounded'} 
                                        onClick={() => handleOpenDay(day,s.id,'fermer')}
                                    >FERMER</p>
                                </div>
                            </div>
                            {s[day+'open'] === true &&
                                <div>
                                    <div className='row border-top' />
                                    <ButtonModalOpen
                                        title='Modifier'
                                        onClick={() => [setChoiceDay(day), setCount(count+1)]}
                                        modal='modalHoursStaff'
                                    />
                                    <div className='mt-3 text-center'>matin 
                                        {s[day+'amOpen'] === true ? 
                                        ' : ' +
                                            _zero(s[day+'hoursAMStart']) + ':' + 
                                            _zero(s[day+'minutesAMStart']) + '  -  ' +
                                            _zero(s[day+'hoursAMEnd']) + ':' + 
                                            _zero(s[day+'minutesAMEnd'])
                                        : ' : fermé'
                                        }
                                    </div>
                                    <div className='mt-3 text-center'>après-midi 
                                        {s[day+'pmOpen'] === true ? 
                                        ' : ' +
                                            _zero(s[day+'hoursPMStart']) + ':' + 
                                            _zero(s[day+'minutesPMStart']) + '  -  ' +
                                            _zero(s[day+'hoursPMEnd']) + ':' + 
                                            _zero(s[day+'minutesPMEnd'])
                                        : ' : fermé'
                                        }
                                    </div>
                                </div>
                            }
                        </>
                        }
                    </div>
                </div>
            ))}

                {/* NUMBER WEEK */}
                <Counter
                    title='Nbr de semaines'
                    _substract={() => _subtractNbrWeeks(s.nbrWeeks)}
                    _add={() => _addNbrWeeks(s.nbrWeeks)}
                    counter={s.nbrWeeks != null ? s.nbrWeeks : '0'}
                />

            </div>
        ))}
        <div style={{height:400}} />
        </>
    )
}

export default ViewDaysStaff



